import { NextPage, NextPageContext } from 'next';
import React from 'react';

import { CampgroundPhotos } from '@/components/route/campground/CampgroundPhotos';
import { getCampgroundListing } from '@/redux/modules/campgroundListing';
import { redirectToSearch, withRedirectToSearch } from '@/services/redirectToSearch';
import { IStore } from '@/utility/redux/store';
import { parseRentalIdFromSlug } from '@/utility/routes';

const ListingPhotos: NextPage = () => {
  return <CampgroundPhotos />;
};

ListingPhotos.getInitialProps = withRedirectToSearch(
  async ({ res, query, pathname, reduxStore }: NextPageContext & { reduxStore: IStore }) => {
    const { slug, location: _, ...remainingParams } = query;
    const rentalId = (slug && parseRentalIdFromSlug(slug)) || '';
    const state = reduxStore.getState();
    const hasListingData = state.campgroundListing.data?.id === Number(rentalId);

    if (rentalId && !hasListingData) {
      const listing = await reduxStore.dispatch(getCampgroundListing(rentalId, remainingParams));
      const listingSlug = listing?.slug;

      // Force redirect if this is a non-campground (e.g. RV listing)
      if (listingSlug && !listingSlug.startsWith('/campground-rental')) {
        return redirectToSearch({ res, query });
      }
      if (listing?.hidden || listing?.has_been_published === false) {
        return redirectToSearch({ res, query }, pathname);
      }
    }

    return { query, pathname, props: {} };
  },
);

export default ListingPhotos;
